import { newToolFilterOAuthMcp } from "../oauth.ts";

export const cdataConnectAiMcpResolver = newToolFilterOAuthMcp({
  iconUrl: "https://www.cdata.com/apple-touch-icon.png",
  url: "https://mcp.cloud.cdata.com/mcp",
  label: "CData Connect AI",
});
